export const SET_COLOR_ONE = 'SET_COLOR_ONE';
export const SET_COLOR_TWO = 'SET_COLOR_TWO';
export const SET_DESIGN_NAME = 'SET_DESIGN_NAME';
export const SET_NAME = 'SET_NAME';
export const SET_FAB_COLOR = 'SET_FAB_COLOR';
export const SET_SHIRT_TYPE = 'SET_SHIRT_TYPE';
export const SET_SIZE = 'SET_SIZE';
